<script lang="ts" setup>
import type { EventMergeRecord } from '@gmao/shared';
import type { MachineStatusLog } from '@gmao/types';
import { MachineName, MaintenanceType } from '@gmao/shared';
import { computed } from 'vue';

const props = defineProps<{
  event: EventMergeRecord;
  events: EventMergeRecord[];
}>();

const log = computed(() => props.event.log as MachineStatusLog);
</script>

<template>
  <div
    flex
    items-center
    gap-1
  >
    <MachineName :name="log.machineName" /> <MaintenanceType :id="log.status" />
  </div>
</template>
